import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** More horizontal — overflow/menu trigger glyph. */
export function IcnMoreHorizontal(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="more-horizontal">
      <circle cx="4" cy="8" r="1" fill="currentColor" stroke="none" />
      <circle cx="8" cy="8" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="8" r="1" fill="currentColor" stroke="none" />
    </Svg>
  );
}
